import { cartInitialState, CartInitialState } from './cart'
import { countryInfoInitialState, CountryInfoInitialState } from './countryInfo'
import { CouponActivatedInitialState, couponsActivatedInitialState } from './couponsActivated'
import { platformInitialState, PlatformInitialState } from './platform'
import { stockAlertInitialState, StockAlertInitialState } from './stockAlert'

export type InitialStateContext = PlatformInitialState &
  CartInitialState &
  CouponActivatedInitialState &
  CountryInfoInitialState &
  StockAlertInitialState

export const initialStateContext: InitialStateContext = {
  ...platformInitialState,
  ...cartInitialState,
  ...couponsActivatedInitialState,
  ...countryInfoInitialState,
  ...stockAlertInitialState,
}
